import { GeneratedComplaint, Language, Tone } from "../types";

// Note: The apiKey parameter is removed/ignored as the backend handles authentication.
export const generateComplaint = async (
  _apiKeyIgnored: string | undefined, 
  language: Language,
  senderName: string,
  company: string,
  incidentDate: string,
  description: string,
  tone: Tone,
  compensationLevel: number,
  imageBase64?: string,
  imageMimeType?: string
): Promise<GeneratedComplaint> => {
  
  const payload = {
    language,
    senderName,
    company,
    incidentDate,
    description,
    tone,
    compensationLevel,
    imageBase64,
    imageMimeType
  };

  const response = await fetch('/api/generate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    console.error("API Error:", errorData);
    throw new Error(errorData.error || 'Failed to generate complaint');
  }

  const data = await response.json();
  return data as GeneratedComplaint;
};